import { useFormikContext } from 'formik';
import { FC } from 'react';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { useLocale } from '../../contexts/localeContext';
import { getAllReportNamesWithPagination } from '../../services/reportService';
import ActivityFrame from '../activity-frame/activity-frame';
import Label from '../label/label';
import PaginatedSearchableSelectField from '../selection-field/paginated-searchable-select-field';

export const NotificationDetails: FC = () => {
    const { translate } = useLocale();
    const { values, setFieldValue } = useFormikContext<any>();

    return (
        <>
            <ActivityFrame className='flex flex-col flex-grow bg-white'>
                <div className="flex flex-row">
                    <div className="flex-col pr-3 w-64">
                        <Label htmlFor='reportType'
                            className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.report)}:</Label>
                        <PaginatedSearchableSelectField
                            name={translate.byKey(TranslationKeys.emailAccount)}
                            key="reportId"
                            accessor="reportId"
                            dataMethod={getAllReportNamesWithPagination}
                            searchAccessor={"trnName"}
                            required={true}
                            onSelect={(event, item) => {
                                setFieldValue("report", item?.label);
                                setFieldValue("reportId", item?.value);
                            }}
                            selectedItemLabel={values.report} />
                    </div>
                </div>
            </ActivityFrame>
        </>
    );
};